import type { ThunkDispatch } from 'editor/src/store/hooks';
import { RootState } from 'editor/src/store/index';
import { requestQuantitySavingsQuantityAction } from 'editor/src/store/quantitySavings/slice';

import sendPostMessage from 'editor/src/util/postMessages/sendPostMessage';

// The quantity lives with the host, which owns the cart and the prices: the editor asks for it and
// shows the result once the host answers with a quote carrying the same sequence.
const changeQuantitySavingsQuantityOperation =
  (quantity: number) =>
  (dispatch: ThunkDispatch, getState: () => RootState): void => {
    dispatch(requestQuantitySavingsQuantityAction(quantity));
    sendPostMessage('quantitySavings.quantityChanged', {
      quantity,
      sequence: getState().quantitySavings.sequence,
    });
  };

export default changeQuantitySavingsQuantityOperation;
